// Angular
import { NgModule } from "@angular/core";
import { PrimeNgModule } from "@primeng";

// BBWT
import { BbFormIOModule } from "@features/bb-formio";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { EpisodeModule } from "@project/episode/episode.module";
import { MultiUserFormSetupService } from "./services/multi-user-form-setup.service";
import { MultiUserFormAccessService } from "./services/multi-user-form-access.service";
import { MultiUserFormSetupComponent } from "./multi-user-form-create-instance/multi-user-form-setup.component";


@NgModule({
    declarations: [
        MultiUserFormSetupComponent
    ],
    imports: [
        PrimeNgModule,
        EpisodeModule,
        BbFormIOModule,
        MiproSharedModule
    ],
    exports: [
        MultiUserFormSetupComponent
    ],
    providers: [
        MultiUserFormSetupService,
        MultiUserFormAccessService,
    ]
})
export class MultiUserFormSetupModule {
}
